// extracted by mini-css-extract-plugin
module.exports = {"button":"CookieSettings_button__32uQg","buttonIcon":"CookieSettings_buttonIcon__Cejqt"};